// types.ts

/**
 * Converts a date to Shamsi (Persian) date format
 * @param date - The date to convert (string, Date object, null, or undefined)
 * @returns Formatted Persian date string or empty string
 */
export type ConvertToShamsiDateFunction = (
  date: string | Date | null | undefined
) => string;

/**
 * Formats a number with thousand separators
 * @param num - The number to format (number, string, null, or undefined)
 * @param locale - The locale to use for formatting (default: "en-US")
 * @param fallbackValue - Value to return if input is invalid (default: "---")
 * @returns Formatted number string or fallback value
 */
export type FormatNumberWithSeparatorFunction = (
  num: number | string | null | undefined,
  locale?: string,
  fallbackValue?: string
) => string;

// Export types for the utility functions
export interface UtilityFunctions {
  ConvertToShamsiDate: ConvertToShamsiDateFunction;
  FormatNumberWithSeparator: FormatNumberWithSeparatorFunction;
}

export function mapAdTypeToListingType(adType?: "supply" | "demand"): number {
  return adType === "supply" ? 2 : 1;
}
export const shouldShow = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "number") return value > 0;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "") return false;
    // Pure numeric strings (e.g. "0") should follow the same rule as numbers
    if (/^-?\d+(\.\d+)?$/.test(trimmed)) return Number(trimmed) > 0;
    return true;
  }
  return true;
};
